export default class ChartOptions {
    getRadial() {
        return {
            plotOptions: {
                radialBar: {
                    startAngle: 0,
                    endAngle: 360,
                    hollow: {
                        margin: 0,
                        size: '25%',
                        background: 'transparent',
                        image: undefined
                    },
                    track: {
                        background: 'rgba(255,255,255, 0.1)',
                        margin: 3,
                        strokeWidth: '90%'
                    }
                }
            },
            legend: {
                show: false
            },
            states: {
                hover: {
                    filter: {
                        type: 'none',
                        value: 0
                    }
                }
            },
            stroke: {
                curve: ['smooth', 'straight'],
                lineCap: "round"
            },
            colors: ['#FFF', '#b8b6b4', 'rgba(255,255,255, 0.1)'],
            labels: []
        };
    }
}



// WEBPACK FOOTER //
// ./resources/site/js/providers/chart.js